import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-part-paye-fac-f',
  templateUrl: './part-paye-fac-f.component.html',
  styleUrls: ['./part-paye-fac-f.component.scss']
})
export class PartPayeFacFComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
